import { useState } from "react";
import { useTranslation } from 'react-i18next';

function Faq() {
  const { t } = useTranslation();
  const [activeQ, setActiveQ] = useState("q1");

  const openQuestion = (id) => {
    setActiveQ(activeQ === id ? "" : id);
  };

  const getAnswerClass = (id) => {
    return activeQ === id ? "active-answer" : "";
  };

  const getQuestionClass = (id) => {
    return activeQ === id ? "active-question" : "";
  };

  return (
    <>
      <section className="faq-section">
        <div className="container">
          <div className="faq-content">
            <div className="faq-content__title">
              <h5>{t('faq.title')}</h5>
              <h2>{t('faq.subtitle')}</h2>
              <p>{t('faq.description')}</p>
            </div>

            <div className="all-questions">
              <div className="faq-box">
                <div
                  id="q1"
                  onClick={() => openQuestion("q1")}
                  className={`faq-box__question ${getQuestionClass("q1")}`}
                >
                  <p>{t('faq.questions.q1.question')}</p>
                  <i className="fa-solid fa-angle-down"></i>
                </div>
                <div
                  id="q1"
                  onClick={() => openQuestion("q1")}
                  className={`faq-box__answer ${getAnswerClass("q1")}`}
                >
                  {t('faq.questions.q1.answer')}
                </div>
              </div>
              <div className="faq-box">
                <div
                  id="q2"
                  onClick={() => openQuestion("q2")}
                  className={`faq-box__question ${getQuestionClass("q2")}`}
                >
                  <p>{t('faq.questions.q2.question')}</p>
                  <i className="fa-solid fa-angle-down"></i>
                </div>
                <div
                  id="q2"
                  onClick={() => openQuestion("q2")}
                  className={`faq-box__answer ${getAnswerClass("q2")}`}
                >
                  {t('faq.questions.q2.answer')}
                </div>
              </div>
              <div className="faq-box">
                <div
                  id="q3"
                  onClick={() => openQuestion("q3")}
                  className={`faq-box__question ${getQuestionClass("q3")}`}
                >
                  <p>{t('faq.questions.q3.question')}</p>
                  <i className="fa-solid fa-angle-down"></i>
                </div>
                <div
                  id="q3"
                  onClick={() => openQuestion("q3")}
                  className={`faq-box__answer ${getAnswerClass("q3")}`}
                >
                  {t('faq.questions.q3.answer')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
